<nav
  class="sticky top-0 z-50 w-full border-b border-white/10 bg-white/90 backdrop-blur-md dark:bg-shl-navy/95 transition-all duration-300 shadow-sm"
  [class.-translate-y-full]="!isNavbarVisible()"
  [class.opacity-0]="!isNavbarVisible()"
  [class.pointer-events-none]="!isNavbarVisible()"
>
  <div class="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-8">
    <div class="flex items-center">
      <img
        src="assets/brand/logo.png"
        [attr.alt]="'navbar.logo_alt' | translate"
        title="{{ 'navbar.logo_alt' | translate }}"
        class="h-12 w-auto md:h-14"
        loading="eager"
        decoding="async"
      />
    </div>
    <div class="hidden items-center gap-8 md:flex">
      <div class="relative group">
        <button
          class="flex items-center gap-1 py-2 text-sm font-semibold text-shl-navy hover:text-shl-sky transition-colors dark:text-gray-300 focus:outline-none"
          type="button"
        >
          {{ 'navbar.services' | translate }}
          <mat-icon
            fontSet="material-symbols-outlined"
            class="text-sm transition-transform group-hover:rotate-180"
          >
            expand_more
          </mat-icon>
        </button>
        <div
          class="absolute left-0 top-full mt-0 w-64 origin-top-left rounded-xl rounded-se-[30px] bg-white p-2 shadow-xl ring-1 ring-black/5 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform translate-y-2 group-hover:translate-y-0 dark:bg-shl-navy-light dark:ring-white/10 z-50"
        >
          <div class="relative group/freight">
            <button
              class="flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-sm font-semibold text-shl-navy hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors"
              type="button"
            >
              <span>{{ 'navbar.services_menu.freight_forwarding_group' | translate }}</span>
              <mat-icon
                fontSet="material-symbols-outlined"
                class="text-[18px] transition-transform group-hover/freight:translate-x-1"
              >
                chevron_right
              </mat-icon>
            </button>
            <div
              class="absolute left-full top-0 ml-2 w-64 rounded-xl rounded-se-[30px] bg-white p-2 shadow-xl ring-1 ring-black/5 opacity-0 invisible group-hover/freight:opacity-100 group-hover/freight:visible transition-all duration-200 dark:bg-shl-navy-light dark:ring-white/10 z-50 rtl:right-full rtl:left-auto rtl:ml-0 rtl:mr-2"
            >
              @for (item of freightForwardingMenu; track item.key) {
                <a
                  class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors"
                  href="#"
                >
                  <mat-icon fontSet="material-symbols-outlined" class="text-[20px] text-shl-sky">
                    {{ item.icon }}
                  </mat-icon>
                  {{ item.key | translate }}
                </a>
              }
            </div>
          </div>
          <div class="my-1 border-t border-gray-100 dark:border-gray-600"></div>
          @for (item of servicesMenuSecondary; track item.key) {
            <a
              class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors"
              href="#"
            >
              <mat-icon fontSet="material-symbols-outlined" class="text-[20px] text-shl-sky">
                {{ item.icon }}
              </mat-icon>
              {{ item.key | translate }}
            </a>
          }
        </div>
      </div>
      <a class="text-sm font-semibold text-shl-navy hover:text-shl-sky transition-colors dark:text-gray-300" href="#">
        {{ 'navbar.network' | translate }}
      </a>
      <a class="text-sm font-semibold text-shl-navy hover:text-shl-sky transition-colors dark:text-gray-300" href="#">
        {{ 'navbar.about' | translate }}
      </a>
    </div>
    <div class="flex items-center gap-4">
      <div class="relative hidden md:flex">
        <button
          class="flex items-center gap-1 text-sm font-semibold text-shl-navy hover:text-shl-sky dark:text-white"
          type="button"
          (click)="toggleLanguageMenu()"
          [attr.aria-expanded]="isLanguageMenuOpen()"
          aria-controls="language-menu"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-[20px]">language</mat-icon>
          {{ 'navbar.language_label' | translate }}
          <mat-icon
            fontSet="material-symbols-outlined"
            class="text-[18px] transition-transform"
            [class.rotate-180]="isLanguageMenuOpen()"
          >
            expand_more
          </mat-icon>
        </button>
        @if (isLanguageMenuOpen()) {
          <div
            id="language-menu"
            class="absolute right-0 mt-3 w-44 rounded-xl bg-white p-2 shadow-xl ring-1 ring-black/5 dark:bg-shl-navy-light dark:ring-white/10 z-50"
          >
            <button
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors text-start"
              type="button"
              (click)="setLanguage('en')"
            >
              🇺🇸 {{ 'navbar.language_english' | translate }}
            </button>
            <button
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors text-start"
              type="button"
              (click)="setLanguage('fr')"
            >
              🇫🇷 {{ 'navbar.language_french' | translate }}
            </button>
            <button
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors text-start"
              type="button"
              (click)="setLanguage('ar')"
            >
              🇹🇳 {{ 'navbar.language_arabic' | translate }}
            </button>
          </div>
        }
      </div>
      <a
        class="btn-gradient hidden sm:flex h-10 items-center justify-center rounded-lg rounded-tr-[20px] px-6 text-sm font-bold text-white shadow-lg shadow-shl-sky/30 transition-transform hover:scale-105"
        href="#quote"
        (click)="scrollToQuote($event)"
      >
        {{ 'navbar.request_quote' | translate }}
      </a>
      <button
        class="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 text-shl-navy transition-colors hover:text-shl-sky dark:border-white/10 dark:text-white md:hidden"
        type="button"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="isMobileMenuOpen()"
        [attr.aria-label]="isMobileMenuOpen() ? ('navbar.menu_close' | translate) : ('navbar.menu_open' | translate)"
        aria-controls="mobile-menu"
      >
        @if (isMobileMenuOpen()) {
          <mat-icon fontSet="material-symbols-outlined" class="text-[22px]">close</mat-icon>
        } @else {
          <mat-icon fontSet="material-symbols-outlined" class="text-[22px]">menu</mat-icon>
        }
      </button>
    </div>
  </div>
  @if (isMobileMenuOpen()) {
    <div
      id="mobile-menu"
      class="md:hidden border-t border-gray-100 bg-white/95 backdrop-blur-md dark:border-white/10 dark:bg-shl-navy/95"
    >
      <div class="px-6 py-4 space-y-4">
        <button
          class="flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm font-semibold text-shl-navy hover:bg-blue-50 hover:text-shl-sky dark:text-white dark:hover:bg-white/10"
          type="button"
          (click)="toggleServicesMenu()"
          [attr.aria-expanded]="isServicesMenuOpen()"
        >
          <span>{{ 'navbar.services' | translate }}</span>
          <mat-icon
            fontSet="material-symbols-outlined"
            class="text-[18px] transition-transform"
            [class.rotate-180]="isServicesMenuOpen()"
          >
            expand_more
          </mat-icon>
        </button>
        @if (isServicesMenuOpen()) {
          <div
            class="space-y-1 rounded-xl bg-white p-2 shadow-sm ring-1 ring-black/5 dark:bg-shl-navy-light dark:ring-white/10"
          >
            <button
              class="flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm font-semibold text-shl-navy hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors"
              type="button"
              (click)="toggleFreightMenu()"
              [attr.aria-expanded]="isFreightMenuOpen()"
            >
              <span>{{ 'navbar.services_menu.freight_forwarding_group' | translate }}</span>
              <mat-icon
                fontSet="material-symbols-outlined"
                class="text-[18px] transition-transform"
                [class.rotate-180]="isFreightMenuOpen()"
              >
                expand_more
              </mat-icon>
            </button>
            @if (isFreightMenuOpen()) {
              <div class="space-y-1 rounded-lg bg-white/80 p-2 shadow-sm dark:bg-shl-navy/60">
                @for (item of freightForwardingMenu; track item.key) {
                  <a
                    class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors"
                    href="#"
                    (click)="closeAllMenus()"
                  >
                    <mat-icon fontSet="material-symbols-outlined" class="text-[18px] text-shl-sky">
                      {{ item.icon }}
                    </mat-icon>
                    {{ item.key | translate }}
                  </a>
                }
              </div>
            }
            <div class="my-1 border-t border-gray-100 dark:border-gray-600"></div>
            @for (item of servicesMenuSecondary; track item.key) {
              <a
                class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white transition-colors"
                href="#"
                (click)="closeAllMenus()"
              >
                <mat-icon fontSet="material-symbols-outlined" class="text-[18px] text-shl-sky">
                  {{ item.icon }}
                </mat-icon>
                {{ item.key | translate }}
              </a>
            }
          </div>
        }
        <a
          class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-semibold text-shl-navy hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white"
          href="#"
          (click)="closeAllMenus()"
        >
          {{ 'navbar.network' | translate }}
        </a>
        <a
          class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-semibold text-shl-navy hover:bg-blue-50 hover:text-shl-sky dark:text-gray-200 dark:hover:bg-white/10 dark:hover:text-white"
          href="#"
          (click)="closeAllMenus()"
        >
          {{ 'navbar.about' | translate }}
        </a>
        <div class="h-px w-full bg-gray-100 dark:bg-white/10"></div>
        <div class="space-y-2">
          <p class="text-xs font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            {{ 'navbar.language_label' | translate }}
          </p>
          <div class="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <button
              class="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-shl-navy hover:border-shl-sky hover:text-shl-sky dark:border-white/10 dark:text-white"
              type="button"
              (click)="setLanguage('en')"
            >
              🇺🇸 {{ 'navbar.language_english' | translate }}
            </button>
            <button
              class="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-shl-navy hover:border-shl-sky hover:text-shl-sky dark:border-white/10 dark:text-white"
              type="button"
              (click)="setLanguage('fr')"
            >
              🇫🇷 {{ 'navbar.language_french' | translate }}
            </button>
            <button
              class="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-shl-navy hover:border-shl-sky hover:text-shl-sky dark:border-white/10 dark:text-white"
              type="button"
              (click)="setLanguage('ar')"
            >
              🇹🇳 {{ 'navbar.language_arabic' | translate }}
            </button>
          </div>
        </div>
        <a
          class="btn-gradient flex h-11 items-center justify-center rounded-lg rounded-tr-[20px] px-6 text-sm font-bold text-white shadow-lg shadow-shl-sky/30 transition-transform hover:scale-105"
          href="#quote"
          (click)="scrollToQuote($event)"
        >
          {{ 'navbar.request_quote' | translate }}
        </a>
      </div>
    </div>
  }
</nav>
